import axios from "axios";
import { Base_URL } from "../url";

export const fetchItemGroup3s = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroup3/GetAllItemGroup3s`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item group 3 data!";
  }
};

export const downloadItemGroup3Excel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup3/DownloadItemGroup3Excel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading item group 3 data!";
  }
};